import {
    CREATE_TUTORIAL_VIDEO,
    DELETE_TUTORIAL_VIDEO,
    EDIT_TUTORIAL_VIDEO,
    GET_TUTORIAL_VIDEOS,
} from './tutorialVideos.types';

/**
 * Everything the org can watch — TherapyLake's videos and its own, merged
 * and tagged `source` by the api.
 */
export const getTutorialVideos = () => {
    return {
        type: GET_TUTORIAL_VIDEOS,
    };
};

/**
 * `body.file` / `body.thumbnail` are the `StoredFile` objects returned by
 * `uploadVideo()` / `uploadFile()` — the bytes are already in S3 by the
 * time this fires. Requires TUTORIAL_VIDEO_MANAGE.
 */
export const createTutorialVideo = (body) => {
    return {
        type: CREATE_TUTORIAL_VIDEO,
        payload: { body },
    };
};

/** Edit one of the org's own videos. Platform videos are not editable. */
export const editTutorialVideo = (id, body) => {
    return {
        type: EDIT_TUTORIAL_VIDEO,
        payload: { id, body },
    };
};

/** Delete one of the org's own videos, and its S3 objects with it. */
export const deleteTutorialVideo = (id) => {
    return {
        type: DELETE_TUTORIAL_VIDEO,
        payload: { id },
    };
};
